module.exports = __webpack_public_path__ + "img/PermissionNone.1120aea3.png";